import { useEffect, useState } from 'react';
import './index.css';
import axios from 'axios';
import { tryCatchJsonParse } from '../../utils/catch/tryCatchJson';
import { use } from 'react';
import { useQueryParms } from '../../hooks/useQueryParams';
import { useNavigate } from 'react-router-dom';
import { sortPlayerByVote } from '../../utils/sortArray';
import DefaultScreen from '../DefaultScreen';
import { useGetGoldebBallInfo } from '../GoldenBallThrophyScreen/hooks/useGetGoldenBallInfo';
import { useHandlerVoting } from '../GoldenBallVotedScreen/hooks/useHandlerVoting';
import GridPlayers from '../GoldenBallVotedScreen/components/GridPlayers';
import { useVoteRedirect } from '../GoldenBallVotedScreen/hooks/useVoteRedirect';
import { adapterPositionLabel, getPositionStatus } from '../GoldenBallVotedScreen/utils/medioTags';
import HeaderGoldenball from '../GoldenBallVotedScreen/components/HeaderGoldenball';
import DescriptionLabel from '../GoldenBallVotedScreen/components/DescriptionLabel';
import useIsMobileAndPortrait from '../../hooks/useIsMobile';
import CarouselPlayers from '../GoldenBallVotedScreen/components/CarouselPlayers';
import LoadingVoteModal from '../GoldenBallVotedScreen/components/LoadingVoteModal';
import ConfirmVoteModal from '../GoldenBallVotedScreen/components/ConfirmVoteModal';

const OnceIdealVotedScreen = ()=>{
    const { goldenBallInfo, isLoading } =  useGetGoldebBallInfo({phase:'eleven'})
    const { handleVoteByPlayer, hasSpecialVote, playersVoted, positionPlayer, isVoting, selectedPlayer, setSelectedPlayer } = useHandlerVoting({
                  goldenBallInfo: goldenBallInfo, 
                  phase:'eleven'})
    const playerByPosition = goldenBallInfo?.nominatedPlayers?.[adapterPositionLabel?.[positionPlayer]]
    const filterPlayers =   sortPlayerByVote(playerByPosition).slice(0, positionPlayer === 'porteros' ? 10 : 10)
    const isVotedEnable = goldenBallInfo?.isEnablePhase?.eleven?.vote


          useVoteRedirect({
          goldenBallInfo, 
          hasSpecialVote,
          playersVoted,
          targetPath: 'graphScreenXI',
          numberVoted: 6,
  
                      })
        const{ isMobile} =  useIsMobileAndPortrait() 
  
    if(isLoading) return <LoadingVoteModal />
    if(!isVotedEnable) return <DefaultScreen  title={`${goldenBallInfo?.name} ${goldenBallInfo?.year}`} description={'La votación para el XI ya termino. Pronto conocerás al XI ideal.'} />
    return(
        <div className='golden-ball-voted-screen-container'>
                <div className='golden-ball-voted-screen-subcontainer'>
                <HeaderGoldenball info={goldenBallInfo} isSpecialVote={hasSpecialVote} />
                <DescriptionLabel phase={'nominate'} position={getPositionStatus(playersVoted) }  />
               {
                isMobile ? <CarouselPlayers players={playerByPosition} vote={setSelectedPlayer}  /> : <GridPlayers players={playerByPosition} vote={setSelectedPlayer}  />
               } 
               {
                 
                selectedPlayer && <ConfirmVoteModal vote={handleVoteByPlayer} 
                player={selectedPlayer} cancel={() => setSelectedPlayer(null)} />

               }
               {isVoting  && <LoadingVoteModal />}
                 </div>
        </div>

    )
}

export default  OnceIdealVotedScreen